import Grid from '@sport1/react-elements/Grid'
import React, { ReactElement } from 'react'
import Label10Font from '../../../../Theme/Fonts/Label10'

type Props = {
    info?: string
}

const AdditionalInfo = ({ info }: Props): ReactElement | null => {
    if (info) {
        return (
            <Grid horizontal paddingTop={2} noExpand flexShrink={0} height={40}>
                <Label10Font color="keshi-4">{info}</Label10Font>
            </Grid>
        )
    }
    return null
}

export default AdditionalInfo
